import { connect } from "react-redux";

import { planAccepted, planDeclined } from "../../../store/plan/actions";
import { get } from "../../../actions/general";

import Notifications from "./lazy";

const mapDispatchToProps = { get, planAccepted, planDeclined };

export default connect(null, mapDispatchToProps)(Notifications);
